import { useRef, useState, useRef as useReactRef } from "react";
import CircleSpinnerLoader from "../../Reusable/LoaderComponent/CircleSpinnerLoader";

interface PrimaryButtonProps {
  primaryButtonText: string;
  onClickPrimaryButton: () => Promise<void> | void;
  onClickSeconderyButton?: () => void;
  variant?: "primary" | "secondary";
  seconderyClassName?: string;
  primaryClassName?: string;
  showSeconderyButton?: boolean;
  showPrimaryButton?: boolean;
  seconderyButtonText?: string;
  primarrybuttonDisable?:boolean;
}

const PrimaryButtonComponent = ({
  primaryButtonText,
  onClickPrimaryButton,
  onClickSeconderyButton,
  variant = "primary",
  primaryClassName = "",
  seconderyClassName = "",
  showSeconderyButton = false,
  showPrimaryButton = false,
  seconderyButtonText = "Cancel",
  primarrybuttonDisable
}: PrimaryButtonProps) => {
  const isProcessingRef = useRef(false);
  const [disabled, setDisabled] = useState(false);
  const buttonRef = useReactRef<HTMLButtonElement>(null);

  const handleClick = async () => {
    if (isProcessingRef.current) return;

    isProcessingRef.current = true;
    setDisabled(true);

    try {
      await onClickPrimaryButton?.();
    } catch (error) {
      console.error("Button click error:", error);
    } finally {
      isProcessingRef.current = false;
      setDisabled(false);
    }
  };

  const baseStyles = "rounded-xl px-6 font-semibold transition-all duration-200 flex items-center justify-center gap-2";
  const variants = {
    primary: "bg-black text-white hover:opacity-90 disabled:opacity-50",
    secondary: "bg-gray-100 text-black border border-gray-300 hover:bg-gray-200 disabled:opacity-50",
  };

  return (
    <div className="flex gap-4 ">
      {showSeconderyButton && (
        <button
          className={` ${seconderyClassName}  rounded-xl px-6 py-2 font-semibold transition-all duration-200 bg-gray-100 text-black border border-gray-300 hover:bg-gray-200`}
          onClick={onClickSeconderyButton}
          type="button"
        >
          {seconderyButtonText}
        </button>
      )}
      {showPrimaryButton && (
        <button
          ref={buttonRef}
          className={`${primaryClassName} ${primarrybuttonDisable&&"cursor-not-allowed"} ${baseStyles} ${variants[variant]} `}
          onClick={handleClick}
          disabled={disabled||primarrybuttonDisable}
        >
          {disabled ? <CircleSpinnerLoader h="20" w="20" /> : primaryButtonText}
        </button>
      )}
    </div>
  );
};

export default PrimaryButtonComponent;
